import cn from 'clsx'
import { MdErrorOutline } from 'react-icons/md'
import { humanFileSize } from '@utils'

const UDDFileDetailsRow = ({
    item,
    fileIsWarning,
    fileIsError,
    fileValidations,
    handleWithTooltipMessage,
    handleWithValidUploadData,
}) => {
    
    return (
        
        <tr className={cn(' w-full', {
            'text-warning': fileIsWarning(item),
            'text-error': fileIsError(item),
        })}>
            
            <td className="w-8">
                <input
                    type="checkbox"
                    className="checkbox checkbox-primary checkbox-sm"
                    checked={fileValidations.isChecked(item.file.name)}
                    disabled={fileIsError(item)}
                    onChange={e =>
                        handleWithValidUploadData(item, e.target.checked)
                    } />
            </td>
            
            <td>
                <span className="inline-block whitespace-nowrap overflow-hidden text-ellipsis">
                    {item.file.name}
                </span>
            </td>
            
            <td>
                <div className="flex items-center gap-2">
                    <MdErrorOutline
                        data-tooltip-id="default-tip"
                        data-tooltip-content={handleWithTooltipMessage(item)}
                        className={cn({
                            'hidden': !fileIsWarning(item) && !fileIsError(item),
                        })} />
                    {humanFileSize(item.file.size, true)}
                </div>
            </td>
        
        </tr>
        
    )
    
}

export default UDDFileDetailsRow
